(ns teamoesterreich.admin-mode.data.blog
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn date-to-restDate [d]
  (let [t (clojure.string/replace (str (.toISOString d)) #"\.|:|-" "")]
    (str (subs t 0 15) "." (subs t 15))))

(defn >new-blog [name finished-fn]
  (ajax/auth-post> (backend/get-auth) (str  backend/BASE_URL "/webBlogs" )
              (ajax/serialize {:webBlog-active true
                               :webBlog-title name
                               :webBlog-published false
                               :webBlog-date (date-to-restDate (js/Date.))
                               :webBlog-content ""})
              (fn [data status]
                (when (= status 200)
                  (finished-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse data))))
                    )))))


(defn >webBlog-edit-img [webBlog-uuid webBlog-imageUri finished-fn]
  (ajax/auth-put> (backend/get-auth) (str  backend/BASE_URL "/webBlogs/" webBlog-uuid)
             (ajax/serialize (merge {:webBlog-uuid webBlog-uuid}
                                    {:webBlog-imageUri webBlog-imageUri}))
             finished-fn))

(defn >webBlog-edit [webBlog-uuid webBlog finished-fn]
  (ajax/auth-put> (backend/get-auth) (str  backend/BASE_URL "/webBlogs/" webBlog-uuid)
             (ajax/serialize (merge webBlog
                                    {:webBlog-uuid webBlog-uuid}))
             finished-fn))

(defn get-blog-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/webBlogs")
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (map (fn [e] [(get e "webBlog-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                    )))))

(defn get-blog [blockUuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/webBlogs/" blockUuid)
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                    )))))
